import { NodeModel } from '../../types';

export function getPathSegment(node: NodeModel, index: number): string {
  return (
    node.tag ??
    (node.moduleSlug
      ? node.moduleSlug + (node.moduleVariant ?? '')
      : undefined) ??
    `${index + 1}`
  );
}
